
import './App.css';
import Hero from './components/Hero';
import Navbar from './components/NavBar';
import 'ionicons';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Contact from './components/Contact';
import Copyright from './components/Copyrights';
import Certifications from './components/Cetifications';
import Skills from './components/Skills';

function App() {
  return (
    <div className="App">
      <Navbar/>
      <Hero/>
      <Skills/>
      <Projects/>
      <Experience/>
      <Certifications/>
      <Contact/>
      <Copyright/>
    </div>
  );
}

export default App;
